import { Skeleton, SkeletonLines } from "@omnabase/ui";

/** The ticket pane while its ticket loads (polish round two): the band, then where the thread will stand, in grey, still blocks. The customer
 *  tags and ticket top round (2026-10-24): no customer header any more; the first block (author, subject, text) and a second one. The pane
 *  says once that it is busy. The ticket style round (2026-10-26): the tags' row (one chip high, a hairline below) stands at the top of the first
 *  block's placeholder, where the tags arrive, so the thread does not jump. */
export function TicketSkeleton() {
  return (
    <section className="ob-detail ob-detail--loading" aria-label="Ticket" aria-busy="true">
      <div className="ob-ticket-bar ob-ticket-bar--empty"><Skeleton shape="line" width="40%" /></div>
      <div className="ob-detail__inner">
        <div className="ob-skeleton-entry">
          <div className="ob-skeleton-tags"><Skeleton shape="line" width={64} height={24} /></div>
          <div className="ob-skeleton-head"><Skeleton shape="block" width={28} height={28} /><Skeleton shape="line" width="30%" /></div>
          <Skeleton shape="line" width="55%" height="1.25em" />
          <SkeletonLines lines={4} />
        </div>
        <Skeleton shape="card" />
      </div>
    </section>
  );
}
